export default __webpack_public_path__ + "static/media/portraitebgtourny.e25c424b.webp";